import { createRouter, createWebHistory } from 'vue-router'
import { safeReturnPath } from '../auth/browser-session.mjs'
import { useAdminAuthStore } from '../store/adminAuth'

const routes = [
  {
    path: '/',
    name: 'PublicHome',
    component: () => import('../views/PublicHomeView.vue')
  },
  {
    path: '/orgs/:orgSlug',
    name: 'OrganizationDetail',
    component: () => import('../views/OrganizationDetailView.vue')
  },
  {
    path: '/orgs/:orgSlug/folders/:folderPath(.*)',
    name: 'FolderDetail',
    component: () => import('../views/FolderDetailView.vue')
  },
  {
    path: '/orgs/:orgSlug/infos/:infoSlug',
    name: 'InfoDetail',
    component: () => import('../views/InfoDetailView.vue')
  },
  {
    path: '/:orgSlug/infos/:infoSlug/html/',
    redirect: (to) => `/orgs/${to.params.orgSlug}/infos/${to.params.infoSlug}`
  },
  {
    path: '/login',
    name: 'LoginBridge',
    component: () => import('../views/LoginBridgeView.vue'),
    meta: { publicAuth: true }
  },
  {
    path: '/login-complete',
    name: 'LoginComplete',
    component: () => import('../views/LoginBridgeView.vue'),
    props: { completion: true },
    meta: { publicAuth: true }
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: () => import('../views/AdminDashboardView.vue'),
    meta: { requiresAdmin: true }
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('../views/UnauthorizedView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAdminAuthStore()

  if (!to.meta.requiresAdmin) {
    next()
    return
  }

  try {
    await authStore.ensureProfile()
  } catch {
    next('/unauthorized')
    return
  }

  if (!authStore.isAuthenticated) {
    const returnPath = safeReturnPath(to.fullPath || '/admin')
    next({ path: '/login', query: { return: returnPath } })
    return
  }

  if (!authStore.isAdmin) {
    next('/unauthorized')
    return
  }

  next()
})

router.afterEach((to) => {
  const titles = {
    PublicHome: 'AutoSquare开放信息',
    OrganizationDetail: '企业信息 - AutoSquare开放信息',
    FolderDetail: '信息目录 - AutoSquare开放信息',
    InfoDetail: '信息详情 - AutoSquare开放信息',
    LoginBridge: '登录 - AutoSquare开放信息',
    LoginComplete: '完成登录 - AutoSquare开放信息',
    AdminDashboard: '管理中心 - AutoSquare开放信息',
    Unauthorized: '权限不足 - AutoSquare开放信息'
  }
  document.title = titles[to.name] || 'AutoSquare开放信息'
})

export default router
